import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const HeritageSection = () => {
  const timeline = [
  {
    year: '1985',
    title: 'The Beginning',
    description: 'Started with grandmother\'s traditional recipes in a small village kitchen'
  },
  {
    year: '2000',
    title: 'Growing Tradition',
    description: 'Expanded to serve local communities while maintaining authentic methods'
  },
  {
    year: '2015',
    title: 'Organic Certification',
    description: 'Received official organic certification and FSSAI compliance'
  },
  {
    year: '2025',
    title: 'Serving Families',
    description: 'Now trusted by 5000+ families across India'
  }];


  return (
    <section id="our-story" className="bg-card py-16 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="mb-12 text-center">
          <h2 className="font-heading mb-4 text-3xl font-bold text-foreground lg:text-4xl">
            Our <span className="text-primary">Heritage Story</span>
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Four generations of preserving traditional Indian food culture
          </p>
        </div>

        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="space-y-8">
            {timeline?.map((item, index) =>
            <div key={index} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
                    <span className="font-cta text-sm font-bold">
                      {item?.year?.slice(-2)}
                    </span>
                  </div>
                  {index < timeline?.length - 1 &&
                <div className="mt-2 h-full w-0.5 bg-border" />
                }
                </div>
                <div className="pb-8">
                  <h3 className="font-heading mb-2 text-xl font-bold text-foreground">
                    {item?.title}
                  </h3>
                  <p className="text-muted-foreground">{item?.description}</p>
                </div>
              </div>
            )}
          </div>

          <div className="space-y-6">
            <div className="overflow-hidden rounded-2xl bg-muted shadow-cta">
              <AppImage
                src="/assets/images/heritage-image-1766910018247.png"
                alt="Traditional Indian grandmother in colorful saree preparing pickles in rustic kitchen with copper utensils"
                className="h-80 w-full object-cover" />

            </div>

            <div className="rounded-2xl bg-background p-6 shadow-cta">
              <Icon
                name="HeartIcon"
                size={32}
                className="mb-4 text-primary" />

              <h3 className="font-heading mb-2 text-xl font-bold text-foreground">
                Family Values, Traditional Methods
              </h3>
              <p className="mb-4 text-muted-foreground">
                What started in our grandmother's kitchen has grown into a mission
                to preserve authentic Indian food traditions. We still use the same
                recipes, the same methods, and the same love that made her cooking
                legendary in our village.
              </p>
              <p className="text-muted-foreground">
                Every product we make honors her legacy and brings the taste of
                tradition to modern families who value health and authenticity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeritageSection;